import myCrypto from '../../libs/MyCrypto.lib'
import myTools from '../../libs/MyTools.lib'

const myErrors = {
  '0x009': {
    text: '該帳號已經存在',
    icon: 'mdi-alert',
    color: 'warning'
  },
  '1x012': {
    text: '該帳號已經存在',
    icon: 'mdi-alert',
    color: 'warning'
  },
  '1x013': {
    text: '該帳號已經存在',
    icon: 'mdi-alert',
    color: 'warning'
  }
}

const state = {
  tableModes: [{ text: '模式1', value: 0, breakpoint: 1 * 1 }],
  tableMode: 0,
  delayTime: process.env.NODE_ENV === 'development' ? 1000 : 0,
  isSending: false,
  isSending2: false,
  // #region AddOnes
  addones: [],
  // #endregion
  // #region AddTwos
  addtwos: [],
  addtwoslist: [],
  // #endregion
  // #region AddThrees
  addthrees: [],
  addthreeslist: [],
  addthreeslist2: [],
  // #endregion
  // #region AddOneList
  addonelistlist1: [],
  addonelistlist2: [],
  addonelistlist3: [],
  addonedetails: [],
  // #endregion
  // #region Admin
  admins: [],
  // #endregion
  // #region Group
  groups: [],
  groupAgentOptions: [],
  // #endregion
  // #region Agent
  agents: [],
  agentGroupOptions: [],
  // #endregion
  // #region Member
  members: [],
  memberGroupOptions: [],
  // #endregion
  // #region GroupDetail
  groupListOptions: [],
  groupBrandOptions: [],
  groupSeriesOptions: [],
  groupOptions: [],
  groupListDetails: [],
  groupDetails: [],
  groupDetailsOwn: [],
  groupDetailOwnPremium: 0,
  groupDetailOwnPremiumP: 0,
  // #endregion
  // #region Board
  boards: [],
  // #endregion
  // #region System
  system: {
    bgImage: null,
    dlFile: null,
    browseCount: 0,
    downloadCount: 0,
    agentLoginEnb: 0
  },
  features: [],
  // #endregion

  // #region Quote
  quotes: [],
  quotelist: [],
  quoteAgents: [],
  // #endregion

  // #region Member Register
  mRegisters: [],
  mGroupOptions: [],
  // #endregion

  // #region Error
  responseStatus: {
    res: false,
    err: null
  },
  // #endregion

  // #region
  // #endregion
  tempData: [],
  nothing: undefined
}

const getters = {}

const mutations = {
  // #region AddOne
  sendUpdateAddOnesRequest(state) {
    state.addones = []
    state.isSending = true
  },
  sendDeleteAddOneRequest(state) {
    state.addones = []
    state.isSending = true
  },
  updateAddOnes(state, d) {
    Object.assign(state.addones, d || [])
    state.isSending = false
  },
  // #endregion
  // #region AddTwo
  sendGatAllAddTwosRequest(state) {
    state.addtwoslist = []
    state.addtwos = []
    state.isSending = true
  },
  sendUpdateAddTwosRequest(state) {
    // state.addtwoslist = []
    state.addtwos = []
    state.isSending = true
  },
  sendDeleteAddTwoRequest(state) {
    // state.addtwoslist = []
    state.addtwos = []
    state.isSending = true
  },
  updateAddTwos(state, d) {
    Object.assign(state.addtwos, d || [])
    state.isSending = false
  },
  updateAddTwosList(state, d) {
    Object.assign(state.addtwoslist, d || [])
    state.isSending = false
  },
  // #endregion
  // #region AddThree
  sendGetAllAddThreesRequest(state) {
    state.addthreeslist = []
    state.addthreeslist2 = []
    state.addthrees = []
    state.isSending = true
  },
  sendUpdateAddThreesRequest(state) {
    // state.addthreeslist = []
    // state.addthreeslist2 = []
    state.addthrees = []
    state.isSending = true
  },
  sendDeleteAddThreeRequest(state) {
    // state.addthreeslist = []
    // state.addthreeslist2 = []
    state.addthrees = []
    state.isSending = true
  },
  updateAddThrees(state, d) {
    Object.assign(state.addthrees, d || [])
    state.isSending = false
  },
  updateAddThreesList(state, d) {
    Object.assign(state.addthreeslist, d || [])
    state.isSending = false
  },
  updateAddThreesList2(state, d) {
    Object.assign(state.addthreeslist2, d || [])
    state.isSending = false
  },
  // #endregion
  // #region AddOneListNew
  sendGetAddOneAllOptionsRequest(state) {
    state.addonelistlist1 = []
    state.addonelistlist2 = []
    state.addonelistlist3 = []
    state.isSending = true
  },
  setUpdateAddOneDetailRequest(state) {
    state.addonedetails = []
    state.isSending = true
  },
  updateAddOneAllOptions(state, d) {
    if (d.list1) Object.assign(state.addonelistlist1, d.list1 || [])
    if (d.list2) Object.assign(state.addonelistlist2, d.list2 || [])
    if (d.list3) Object.assign(state.addonelistlist3, d.list3 || [])
    state.isSending = false
  },
  updateAddOneDetails(state, d) {
    Object.assign(state.addonedetails, d || [])
    state.isSending = false
  },
  // #endregion
  // #region Admin
  setUpdateAdminsRequest(state) {
    state.admins = []
    state.isSending = true
  },
  updateAdmins(state, d) {
    d.forEach(e => {
      e.pass = window.atob(e.pass)
    })
    Object.assign(state.admins, d || [])
    state.isSending = false
  },
  // #endregion
  // #region Group
  setUpdateGroupRequest(state) {
    state.groups = []
    state.isSending = true
  },
  updateGroups(state, d) {
    Object.assign(state.groups, d.res || [])
    Object.assign(state.groupAgentOptions, d.agent || [])
    state.isSending = false
  },
  // #endregion
  // #region Agent
  setUpdateAgentsRequest(state) {
    if (state.agents.length > 0) Object.assign(state.tempData, state.agents)
    state.responseStatus.res = false
    state.responseStatus.err = null

    state.agents = []
    state.isSending = true
  },
  updateAgents(state, d) {
    if (!d.res || !d.group) {
      state.isSending = false
      return
    }
    Object.assign(state.agentGroupOptions, d.group || [])

    // d.res.forEach(e => {
    //   if (e.password) e.password = window.atob(e.password)
    // })
    Object.assign(state.agents, d.res || [])

    state.isSending = false
  },
  addAgentFaile(state, d) {
    Object.assign(state.agents, state.tempData)
    state.responseStatus.err = d ? d.err || null : null
    state.isSending = false
  },
  // #endregion
  // #region Member
  setUpdateMembersRequest(state) {
    if (state.members.length > 0) Object.assign(state.tempData, state.members)
    state.responseStatus.res = false
    state.responseStatus.err = null

    state.members = []
    state.isSending = true
  },
  updateMembers(state, d) {
    if (!d.res || !d.group) {
      state.isSending = false
      return
    }
    Object.assign(state.memberGroupOptions, d.group || [])

    // d.res.forEach(e => {
    //   e.pass = window.atob(e.pass)
    // })
    Object.assign(state.members, d.res || [])

    state.isSending = false
  },
  addMemberFaile(state, d) {
    Object.assign(state.members, state.tempData)
    state.responseStatus.err = d ? d.err || null : null
    state.isSending = false
  },
  // #endregion
  // #region GroupDetail
  setUpdateGroupDetailsRequest(state) {
    state.groupListDetails = []
    state.isSending = true
  },
  setUpdateGroupDetailsByGroupRequest(state) {
    state.groupDetails = []
    state.isSending = true
  },
  updateGroupDetails(state, d) {
    if (d.list) Object.assign(state.groupListOptions, d.list)
    Object.assign(state.groupBrandOptions, d.brand || [])
    Object.assign(state.groupSeriesOptions, d.series || [])
    Object.assign(state.groupOptions, d.group || [])
    Object.assign(state.groupListDetails, d.res || [])
    Object.assign(state.groupDetails, d.groupdetail || [])
    Object.assign(state.groupDetailsOwn, d.groupdetailown || [])

    state.groupDetailOwnPremium = d.premium || 0
    state.groupDetailOwnPremiumP = d.premium_p || 0

    state.isSending = false
  },
  updateGroupDetailsByGroup(state, d) {
    Object.assign(state.groupDetails, d.groupdetail || [])
    state.isSending = false
  },
  // #endregion
  // #region Board
  setUpdateBoardRequest(state) {
    state.boards = []
    state.isSending = true
  },
  updateBoards(state, d) {
    Object.assign(state.boards, d.res || [])
    state.isSending = false
  },
  // #endregion
  // #region System
  setUpdateSystem(state) {
    state.isSending = true
    state.system = {
      bgImage: null,
      dlFile: null,
      browseCount: 0,
      downloadCount: 0,
      agentLoginEnb: 0
    }
  },
  updateSystem(state, d) {
    // if (!d.res) return
    // if (!d.res.length < 1) return
    // const row = d.res[0]
    state.system = {
      bgImage: d['bg_image'],
      dlFile: d['download_file'],
      browseCount: d['browse_count'],
      downloadCount: d['download_count'],
      agentLoginEnb: d['agent_login_enb']
    }

    if (d.feature) state.features = d.feature

    state.isSending = false
  },
  // #endregion

  // #region Quote
  setUpdateQuote(state) {
    state.isSending = true
    state.quotes = []
  },
  updateQuote(state, d) {
    Object.assign(state.quotes, d.quote || [])
    Object.assign(state.quoteAgents, d.agent || [])
    state.isSending = false
  },
  setUpdateQuoteList(state) {
    state.isSending2 = true
    state.quotelist = []
  },
  updateQuoteList(state, d) {
    Object.assign(state.quotelist, d.quotelist || [])
    state.isSending2 = false
  },
  // #endregion

  // #region Member Register
  setUpdateMemberRegister(state) {
    state.mRegisters = []
    state.isSending = true
  },
  updateMemberRegister(state, d) {
    if (d.register) state.mRegisters = d.register
    if (d.groupoption) state.mGroupOptions = d.groupoption
    state.isSending = false
  },
  // #endregion

  // #region
  // #endregion
  resetResponseStatus(state) {
    state.responseStatus.err = null
    state.responseStatus.res = false
  },
  nothing() {}
}

const actions = {
  // #region AddOne
  saveAddOne({ state, commit, dispatch }, { addone, uid, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOne.php`
        : 'api/addOne.php'
    commit('sendUpdateAddOnesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'addone', value: addone },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOnes', out)
    })
  },
  getAddOnes({ commit, dispatch }, { uid }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneSelect.php`
        : 'api/addOneSelect.php'
    // commit('sendRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [{ key: 'uid', value: uid }],
        url: url
      },
      { root: true }
    ).then(res => {
      let out = []
      if (res.data) out = res.data.res
      commit('updateAddOnes', out)
    })
  },
  updateAddOnes({ state, commit, dispatch }, { addone, uid, id, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneUpdate.php`
        : 'api/addOneUpdate.php'
    commit('sendUpdateAddOnesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'addone', value: addone },
          { key: 'id', value: id },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOnes', out)
    })
  },
  deleteAddOne({ state, commit, dispatch }, { uid, ids }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneDelete.php`
        : 'api/addOneDelete.php'
    commit('sendDeleteAddOneRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'ids', value: JSON.stringify(ids) }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOnes', out)
    })
  },
  // #endregion
  // #region AddTwo
  getAddTwos({ commit, dispatch }, { uid }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addTwoSelect.php`
        : 'api/addTwoSelect.php'
    commit('sendGatAllAddTwosRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [{ key: 'uid', value: uid }],
        url: url
      },
      { root: true }
    ).then(res => {
      let out = []
      if (res.data) out = res.data.res
      commit('updateAddTwos', out)

      out = []
      if (res.data.list) out = res.data.list
      commit('updateAddTwosList', out)
    })
  },
  updateAddTwos({ state, commit, dispatch }, { addone, uid, id, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addTwoUpdate.php`
        : 'api/addTwoUpdate.php'
    commit('sendUpdateAddTwosRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'name', value: addone },
          { key: 'id', value: id },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddTwos', out)
    })
  },
  deleteAddTwo({ state, commit, dispatch }, { uid, ids }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addTwoDelete.php`
        : 'api/addTwoDelete.php'
    commit('sendUpdateAddTwosRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'ids', value: JSON.stringify(ids) }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddTwos', out)
    })
  },
  saveAddTwo({ state, commit, dispatch }, { addone, list_id, uid, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addTwo.php`
        : 'api/addTwo.php'
    commit('sendUpdateAddTwosRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'name', value: addone },
          { key: 'list_id', value: list_id },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddTwos', out)
    })
  },
  // #endregion
  // #region AddThree
  getAddThrees({ commit, dispatch }, { uid }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addThreeSelect.php`
        : 'api/addThreeSelect.php'
    commit('sendGetAllAddThreesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [{ key: 'uid', value: uid }],
        url: url
      },
      { root: true }
    ).then(res => {
      let out = []
      if (res.data) out = res.data.res
      commit('updateAddThrees', out)

      out = []
      if (res.data.list) out = res.data.list
      commit('updateAddThreesList', out)

      out = []
      if (res.data.list2) out = res.data.list2
      commit('updateAddThreesList2', out)
    })
  },
  updateAddThrees({ state, commit, dispatch }, { addone, uid, id, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addThreeUpdate.php`
        : 'api/addThreeUpdate.php'
    commit('sendUpdateAddThreesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'name', value: addone },
          { key: 'id', value: id },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      let out = []
      if (res.data) out = res.data.res
      commit('updateAddThrees', out)
    })
  },
  saveAddThree({ state, commit, dispatch }, { addone, brand_id, uid, enb }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addThree.php`
        : 'api/addThree.php'
    commit('sendUpdateAddThreesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'name', value: addone },
          { key: 'brand_id', value: brand_id },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddThrees', out)
    })
  },
  deleteAddThree({ state, commit, dispatch }, { uid, ids }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addThreeDelete.php`
        : 'api/addThreeDelete.php'
    commit('sendUpdateAddThreesRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'ids', value: JSON.stringify(ids) }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddThrees', out)
    })
  },
  // #endregion
  // #region AddOneListNew
  getAddOneAllOptionList({ commit, dispatch }, { uid }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneGetOptions.php`
        : 'api/addOneGetOptions.php'
    commit('sendGetAddOneAllOptionsRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [{ key: 'uid', value: uid }],
        url: url
      },
      { root: true }
    ).then(res => {
      if (!res.data) return
      commit('updateAddOneAllOptions', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  saveAddOneDetail({ state, commit, dispatch }, { addoneModel, addonePrice, uid, enb, l_id, b_id, b_name, s_id, s_name }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneDetailNew.php`
        : 'api/addOneDetailNew.php'
    commit('setUpdateAddOneDetailRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'model', value: addoneModel },
          { key: 'price', value: addonePrice },
          { key: 'enb', value: enb },
          { key: 'list_id', value: l_id },
          { key: 'brand_id', value: b_id },
          { key: 'series_id', value: s_id },
          { key: 'brand_name', value: b_name },
          { key: 'series_name', value: s_name },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOneDetails', out)
    })
  },
  getAddOneDetails({ state, commit, dispatch }, { uid, l_id }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneDetailSelect.php`
        : 'api/addOneDetailSelect.php'
    commit('setUpdateAddOneDetailRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'list_id', value: l_id },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOneDetails', out)
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateAddOneDetail({ state, commit, dispatch }, { uid,l_id,id,addoneModel,oldPrice,newPrice,rf,ap,enb}) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneDetailUpdate.php`
        : 'api/addOneDetailUpdate.php'
    commit('setUpdateAddOneDetailRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'l_id', value: l_id },
          { key: 'id', value: id },
          { key: 'model', value: addoneModel },
          { key: 'old_price', value: oldPrice },
          { key: 'new_price', value: newPrice },
          { key: 'rf', value: rf },
          { key: 'ap', value: ap },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOneDetails', out)
    })
  },
  deleteAddOneDetail({ state, commit, dispatch }, { uid, ids, l_id }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/addOneDetailDelete.php`
        : 'api/addOneDetailDelete.php'
    commit('setUpdateAddOneDetailRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'l_id', value: l_id },
          { key: 'ids', value: JSON.stringify(ids) }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      let out = []
      if (res.data) out = res.data.res
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateAddOneDetails', out)
    })
  },
  // #endregion
  // #region Admin
  // eslint-disable-next-line no-unused-vars
  getAllAdmins({ commit, dispatch }, { uid, level }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/adminSelect.php`
        : 'api/adminSelect.php'
    commit('setUpdateAdminsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'level', value: level },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAdmins', decryptdata.res || [])
    })
  },
  addAdmin({ state, commit, dispatch }, { uid, user, pass, enb, level }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/adminNew.php`
        : 'api/adminNew.php'
    commit('setUpdateAdminsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'user', value: user },
          { key: 'pass', value: pass },
          { key: 'level', value: level },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAdmins', decryptdata.res || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateAdmin({ state, commit, dispatch }, { uid, id, user, pass, enb, level }) {
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/adminUpdate.php`
        : 'api/adminUpdate.php'
    commit('setUpdateAdminsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'id', value: id },
          { key: 'user', value: user },
          { key: 'pass', value: pass },
          { key: 'level', value: level },
          { key: 'enb', value: enb }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAdmins', decryptdata.res || [])
    })
  },
  deleteAdmin({ state, commit, dispatch }, { uid, ids, level }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/adminDelete.php`
        : 'api/adminDelete.php'
    commit('setUpdateAdminsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'uid', value: uid },
          { key: 'ids', value: ids },
          { key: 'level', value: level }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAdmins', decryptdata.res || [])
    })
  },
  // #endregion
  // #region Group
  getAllGroups({ commit, dispatch }, { uid, user, level }) {
    const path = 'groupSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(res => {
      commit('updateGroups', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  addGroup({ state, commit, dispatch }, { premium, premium_p, uid, ad_id, ag_id, name, tag, user, level, enb }) {
    const path = 'groupNew.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'premium', value: premium },
          { key: 'premium_p', value: premium_p },
          { key: 'ad_id', value: ad_id },
          { key: 'ag_id', value: ag_id },
          { key: 'name', value: name },
          { key: 'tag', value: tag },
          { key: 'enb', value: enb },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroups', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateGroup({ state, commit, dispatch }, { premium, premium_p, uid, id, name, tag, user, level, enb }) {
    const path = 'groupUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'premium', value: premium },
          { key: 'premium_p', value: premium_p },
          { key: 'id', value: id },
          { key: 'name', value: name },
          { key: 'tag', value: tag },
          { key: 'enb', value: enb },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroups', res.data)
    })
  },
  deleteGroup({ state, commit, dispatch }, { uid, ids, user, level }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const path = 'groupDelete.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'ids', value: ids },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroups', res.data)
    })
  },
  // #endregion
  // #region Agent
  getAllAgents({ commit, dispatch }, { uid, user }) {
    const path = 'agentSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateAgentsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAgents', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  addAgent({ state, commit, dispatch }, { g_id, ad_id, uid, user, username, pass, enb }) {
    const path = 'agentNew.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateAgentsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'username', value: username },
          { key: 'pass', value: pass },
          { key: 'enb', value: enb },
          { key: 'ad_id', value: ad_id },
          { key: 'g_id', value: g_id },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      if (!res.data) return

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: 'mdi-alert' }
        commit('addAgentFaile', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAgents', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateAgent({ state, commit, dispatch }, { id, g_id, uid, user, username, pass, enb }) {
    const path = 'agentUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateAgentsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'username', value: username },
          { key: 'pass', value: pass },
          { key: 'enb', value: enb },
          { key: 'id', value: id },
          { key: 'g_id', value: g_id },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      if (!res.data) return

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: 'mdi-alert' }
        commit('addAgentFaile', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAgents', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  deleteAgent({ state, commit, dispatch }, { ids, uid, user }) {
    const path = 'agentDelete.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateAgentsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'ids', value: ids },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAgents', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateAgentContact({ state, commit, dispatch }, { c_id, name, phone, line, material, memo, user, uid }) {
    const path = 'agentUpdateContact.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateAgentsRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'contact_id', value: c_id },
          { key: 'name', value: name },
          { key: 'phone', value: phone },
          { key: 'line', value: line },
          { key: 'material', value: material },
          { key: 'memo', value: memo },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateAgents', decryptdata || [])
    })
  },
  // #endregion
  // #region Member
  getAllMembers({ commit, dispatch }, { level, uid, user }) {
    const path = 'memberSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMembersRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'level', value: level },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateMembers', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  addMember({ state, commit, dispatch }, { level, username, pass, enb, ad_id, ag_id, g_id, user, uid }) {
    const path = 'memberNew.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMembersRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'level', value: level },
          { key: 'username', value: username },
          { key: 'pass', value: pass },
          { key: 'enb', value: enb },
          { key: 'ad_id', value: ad_id },
          { key: 'ag_id', value: ag_id },
          { key: 'g_id', value: g_id },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      if (!res.data) return

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: 'mdi-alert' }
        commit('addMemberFaile', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateMembers', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateMember({ state, commit, dispatch }, { level, username, pass, enb, id, g_id, user, uid }) {
    const path = 'memberUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMembersRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'level', value: level },
          { key: 'username', value: username },
          { key: 'pass', value: pass },
          { key: 'enb', value: enb },
          { key: 'id', value: id },
          { key: 'g_id', value: g_id },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      if (!res.data) return

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: 'mdi-alert' }
        commit('addMemberFaile', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateMembers', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  deleteMember({ state, commit, dispatch }, { level, ids, user, uid }) {
    const path = 'memberDelete.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMembersRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'level', value: level },
          { key: 'ids', value: ids },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateMembers', decryptdata || [])
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateMemberContact({ state, commit, dispatch }, { agentId, memberId, level, c_id, name, phone, line, material, memo, user, uid }) {
    const path = 'memberUpdateContact.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMembersRequest')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'agent_id', value: agentId },
          { key: 'member_id', value: memberId },
          { key: 'level', value: level },
          { key: 'contact_id', value: c_id },
          { key: 'name', value: name },
          { key: 'phone', value: phone },
          { key: 'line', value: line },
          { key: 'material', value: material },
          { key: 'memo', value: memo },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return

      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))

      commit('updateMembers', decryptdata || [])
    })
  },
  // #endregion
  // #region GroupDetail
  getAllGroupDetails({ state, commit, dispatch }, { uid, user, level }) {
    const path = 'groupDetailSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupDetailsRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroupDetails', res.data)
    })
  },
  getOneGroupDetail({ state, commit, dispatch }, { l_id, uid, user, level }) {
    const path = 'groupDetailSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupDetailsRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'l_id', value: l_id },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroupDetails', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  getOneGroupDetailByGroup({ state, commit, dispatch }, { g_id, l_id, uid, user, level }) {
    const path = 'groupDetailSelectByGroup.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupDetailsByGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'g_id', value: g_id },
          { key: 'l_id', value: l_id },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroupDetailsByGroup', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateGroupDetail({ state, commit, dispatch }, { d_id, g_id, id, u_price, enb, uid, user, level }) {
    const path = 'groupDetailUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateGroupDetailsByGroupRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'd_id', value: d_id },
          { key: 'g_id', value: g_id },
          { key: 'id', value: id },
          { key: 'u_price', value: u_price },
          { key: 'enb', value: enb },
          { key: 'user', value: user },
          { key: 'l', value: window.btoa(level) },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateGroupDetailsByGroup', res.data)
    })
  },
  addGroupDetail() {},
  // #endregion
  // #region Board
  getAllBoards({ state, commit, dispatch }, { uid, user }) {
    const path = 'boardSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateBoardRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateBoards', res.data)
    })
  },
  addBoard({ state, commit, dispatch }, { name, enb, content, uid, user }) {
    const path = 'boardNew.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateBoardRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'name', value: name },
          { key: 'enb', value: enb },
          { key: 'content', value: content },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateBoards', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  updateBoard({ state, commit, dispatch }, { id, name, enb, content, uid, user }) {
    const path = 'boardUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateBoardRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'id', value: id },
          { key: 'name', value: name },
          { key: 'enb', value: enb },
          { key: 'content', value: content },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateBoards', res.data)
    })
  },
  deleteBoard({ state, commit, dispatch }, { ids, user, uid }) {
    if (!ids) return
    if (!ids.length) return
    if (ids.length < 1) return
    const path = 'boardDelete.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateBoardRequest')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'ids', value: ids },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateBoards', res.data)
    })
  },
  // #endregion
  // #region System
  getSystem({ state, commit, dispatch }, { uid, user }) {
    const path = 'SystemSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateSystem')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateSystem', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  uploadBgImage({ state, commit, dispatch }, { bgName, dlName, file, uid, user }) {
    const path = 'SystemBgImageUpload.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateSystem')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'bgName', value: bgName || '' },
          { key: 'dlName', value: dlName || '' },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        files: [{ key: 'bgImage', value: file }],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateSystem', res.data)
    })
  },
  updateSystem({ state, commit, dispatch }, { id, request, enb, uid, user }) {
    const path = 'SystemUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateSystem')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'id', value: id },
          { key: 'request', value: request },
          { key: 'enb', value: enb },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateSystem', res.data)
    })
  },
  // #endregion

  // #region Quote
  // eslint-disable-next-line prettier/prettier
  getAllQuotes({ state, commit, dispatch }, { quote_id ,ag_id, level, user, uid }) {
    const path = 'quoteSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateQuote')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'quote_id', value: quote_id || '' },
          { key: 'ag_id', value: ag_id },
          { key: 'l', value: window.btoa(level) },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateQuote', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  getQuoteList({ state, commit, dispatch }, { quote_id ,ag_id, level, user, uid }) {
    const path = 'quoteSelect.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateQuoteList')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'quote_id', value: quote_id || '' },
          { key: 'ag_id', value: ag_id },
          { key: 'l', value: window.btoa(level) },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateQuoteList', res.data)
    })
  },
  // eslint-disable-next-line prettier/prettier
  closeQuote({ state, commit, dispatch }, { ag_id, quote_id, level, user, uid }) {
    const path = 'quoteUpdate.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateQuote')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'ag_id', value: ag_id },
          { key: 'quote_id', value: quote_id || '' },
          { key: 'l', value: window.btoa(level) },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateQuote', res.data)
    })
  },
  // #endregion

  // #region Member Register
  // eslint-disable-next-line prettier/prettier
  getAllMemberReigster({ state, commit, dispatch }, { user, uid }) {
    const path = 'memberRegister.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMemberRegister')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'request', value: 'getall' },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateMemberRegister', res.data)
    })
  },
  passMemberReigster({ state, commit, dispatch }, { info, user, uid }) {
    const path = 'memberRegister.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMemberRegister')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'request', value: 'pass1' },
          { key: 'info', value: info },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateMemberRegister', res.data)
    })
  },
  deleteReigster({ state, commit, dispatch }, { mr_id, user, uid }) {
    const path = 'memberRegister.php'
    const url =
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/${path}`
        : `api/${path}`
    commit('setUpdateMemberRegister')
    return dispatch(
      'sendRequestWithOtherUrl',
      {
        params: [
          { key: 'request', value: 'del1' },
          { key: 'mr_id', value: mr_id },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ],
        url: url
      },
      { root: true }
    ).then(async res => {
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateMemberRegister', res.data)
    })
  },
  // #endregion

  // #region
  // #endregion
  nothing() {}
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
